export const version = "v3.1.0"
export const user_help_doc_url = "https://mp.weixin.qq.com/s/8ynXfpW446Fi5mB0OZ-Pcw"
export const wikiDisabled = true
